<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.search.plate.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    
                    <!-- Form row -->
                    <div  class="row">
                        <div class="col-md-12">
                            <div  class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.menu.search.admin.details.plate.label.title')}}
                                </p>

                                <form>
                                    <div class="form-row">
                                       <div class="form-group col-md-3">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.truck.register.label.plate')}}
                                            </label>
                                            <input type="text" class="form-control" v-model="plate" v-mask="['AAA-####']" :placeholder="$t('string.msg.truck.register.placeholder.plate')">
                                        </div>
                                      
                                    </div>
                                    <br/>
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
                                      <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                                    </div>

                                    <div class="form-row">
                                       <div class="form-group col-md-12">
                                           {{item}}
                                        </div>
                                      
                                    </div>


                                </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtPlate';
import Spinner from '../../components/layout/Spinner';
import Toast from '../../components/layout/Toast';

export default {
  name: 'searchPlate',
  components: {
    Spinner,
    Toast
  },
  data() {
      return {
        errors: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        plate: null,
        item: null
      }
  },
  methods: Controller.methods,
  created() {
  },
  mounted(){
    Controller.init(this);
  }
}
</script>

<style>
</style>
